import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full overflow-y-auto p-6 bg-slate-50 dark:bg-slate-900/50 flex flex-col gap-6" }
const _hoisted_2 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_3 = { class: "font-semibold text-lg border-b pb-2 flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-center text-muted-foreground py-4 text-xs border border-dashed rounded"
}
const _hoisted_5 = { class: "grid grid-cols-1 2xl:grid-cols-2 gap-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "grid grid-cols-2 gap-2 pr-8" }
const _hoisted_8 = { class: "flex flex-col gap-1" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "flex flex-col gap-1" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_14 = { class: "flex flex-col gap-1" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "flex flex-col gap-1" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "flex flex-col gap-1 mt-1" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_25 = { class: "font-semibold text-lg border-b pb-2 flex items-center gap-2" }
const _hoisted_26 = {
  key: 0,
  class: "text-center text-muted-foreground py-4 text-xs border border-dashed rounded"
}
const _hoisted_27 = { class: "grid grid-cols-1 2xl:grid-cols-2 gap-4" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "grid grid-cols-2 gap-2 pr-8" }
const _hoisted_30 = { class: "flex flex-col gap-1" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "flex flex-col gap-1" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "flex flex-col gap-1 mt-1" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_37 = { class: "font-semibold text-lg border-b pb-2 flex items-center gap-2" }
const _hoisted_38 = {
  key: 0,
  class: "text-center text-muted-foreground py-4 text-xs border border-dashed rounded"
}
const _hoisted_39 = { class: "flex flex-col gap-2" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { label: "Elementos" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { label: "Requisitos" }
const _hoisted_44 = ["value"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = ["value"]
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { label: "Requisitos" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { label: "Elementos" }
const _hoisted_51 = ["value"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "text-sm font-bold p-2 bg-muted-foreground/10 text-muted-foreground flex items-center justify-between border-b shrink-0" }

import { ref, watch } from 'vue'
import { Button } from '@/components/ui/button'
import { ClipboardList, Plus, Trash2, RefreshCw, Box, Link2, FileCheck2 } from 'lucide-vue-next'
import BaseVisualEditor from './BaseVisualEditor.vue'
import MermaidCodeEditor from './MermaidCodeEditor.vue'
import MermaidLivePreview from './MermaidLivePreview.vue'

interface Requirement {
  name: string
  type: string
  id: string
  text: string
  risk: string
  verifyMethod: string
}

interface ReqElement {
  name: string
  type: string
  docRef: string
}

interface ReqRelation {
  source: string
  type: string
  target: string
}

// Estados visuales

export default /*@__PURE__*/_defineComponent({
  __name: 'RequirementEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const showCode = ref(true)
const copied = ref(false)
const editableCode = ref('')

// Interfaces
const requirements = ref<Requirement[]>([
  {
    name: 'Req_Autenticacion',
    type: 'requirement',
    id: 'REQAUTH01',
    text: 'El sistema debe permitir el inicio de sesión.',
    risk: 'high',
    verifyMethod: 'test'
  }
])

const elements = ref<ReqElement[]>([
  {
    name: 'Modulo_Login',
    type: 'software_component',
    docRef: 'doc_123'
  }
])

const relations = ref<ReqRelation[]>([
  {
    source: 'Modulo_Login',
    type: 'satisfies',
    target: 'Req_Autenticacion'
  }
])

// Catálogos
const reqTypes = [
  'requirement', 'functionalRequirement', 'interfaceRequirement', 
  'performanceRequirement', 'physicalRequirement', 'designConstraint'
]
const riskTypes = ['low', 'medium', 'high']
const verifyTypes = ['analysis', 'demonstration', 'inspection', 'test']
const relationTypes = ['contains', 'copies', 'derives', 'satisfies', 'verifies', 'refines', 'traces']

// Acciones Requerimientos
const addRequirement = () => {
  requirements.value.push({
    name: `Req_${requirements.value.length + 1}`,
    type: 'requirement',
    id: `REQ-${requirements.value.length + 1}`,
    text: 'Descripción del requisito.',
    risk: 'medium',
    verifyMethod: 'inspection'
  })
}
const removeRequirement = (idx: number) => {
  requirements.value.splice(idx, 1)
}

// Acciones Elementos
const addElement = () => {
  elements.value.push({
    name: `Elemento_${elements.value.length + 1}`,
    type: 'component',
    docRef: ''
  })
}
const removeElement = (idx: number) => {
  elements.value.splice(idx, 1)
}

// Acciones Relaciones
const addRelation = () => {
  const allNames = [...requirements.value.map(r => r.name), ...elements.value.map(e => e.name)]
  const source = allNames.length > 0 ? allNames[allNames.length - 1] : ''
  const target = allNames.length > 1 ? allNames[0] : source
  relations.value.push({
    source,
    type: 'satisfies',
    target
  })
}
const removeRelation = (idx: number) => {
  relations.value.splice(idx, 1)
}

// Utils
const formatName = (name: string) => name.trim().replace(/\s+/g, '_')

// Generar Mermaid
const generateMermaid = () => {
  let code = `requirementDiagram\n\n`

  requirements.value.forEach(req => {
    const safeName = formatName(req.name)
    if (!safeName) return
    const safeId = req.id.replace(/[^a-zA-Z0-9]/g, '') || 'ID1'
    code += `  ${req.type} ${safeName} {\n`
    code += `    id: ${safeId}\n`
    code += `    text: ${req.text || 'Sin texto'}\n`
    code += `    risk: ${req.risk}\n`
    code += `    verifymethod: ${req.verifyMethod}\n`
    code += `  }\n\n`
  })

  elements.value.forEach(el => {
    const safeName = formatName(el.name)
    if (!safeName) return
    code += `  element ${safeName} {\n`
    code += `    type: ${el.type || 'unknown'}\n`
    if (el.docRef.trim()) {
      code += `    docRef: ${el.docRef.trim()}\n`
    }
    code += `  }\n\n`
  })

  relations.value.forEach(rel => {
    const src = formatName(rel.source)
    const tgt = formatName(rel.target)
    if (src && tgt) {
      code += `  ${src} - ${rel.type} -> ${tgt}\n`
    }
  })
  
  editableCode.value = code
}

// Sincronizar desde Código a Visual
const syncToVisual = () => {
  const code = editableCode.value
  const lines = code.split('\n')
  
  const newReqs: Requirement[] = []
  const newElems: ReqElement[] = []
  const newRels: ReqRelation[] = []
  
  const reqStartRegex = /^(requirement|functionalRequirement|interfaceRequirement|performanceRequirement|physicalRequirement|designConstraint)\s+([^{]+)\s*{/
  const elemStartRegex = /^element\s+([^{]+)\s*{/
  const relationRegex = /^([a-zA-Z0-9_]+)\s*-\s*([a-zA-Z0-9_]+)\s*->\s*([a-zA-Z0-9_]+)/
  
  let currentBlock: 'req' | 'elem' | null = null
  let currentObj: any = null

  for (const line of lines) {
    const tLine = line.trim()
    if (!tLine || tLine === 'requirementDiagram') continue

    // Detect block end
    if (tLine === '}') {
      if (currentBlock === 'req' && currentObj) {
        newReqs.push(currentObj as Requirement)
      } else if (currentBlock === 'elem' && currentObj) {
        newElems.push(currentObj as ReqElement)
      }
      currentBlock = null
      currentObj = null
      continue
    }

    // Process block contents
    if (currentBlock === 'req') {
      if (tLine.startsWith('id:')) currentObj.id = tLine.replace('id:', '').trim()
      else if (tLine.startsWith('text:')) currentObj.text = tLine.replace('text:', '').trim()
      else if (tLine.startsWith('risk:')) currentObj.risk = tLine.replace('risk:', '').trim()
      else if (tLine.startsWith('verifymethod:')) currentObj.verifyMethod = tLine.replace('verifymethod:', '').trim()
      continue
    }

    if (currentBlock === 'elem') {
      if (tLine.startsWith('type:')) currentObj.type = tLine.replace('type:', '').trim()
      else if (tLine.startsWith('docref:')) currentObj.docRef = tLine.replace('docref:', '').trim()
      continue
    }

    // Detect new blocks or relations
    if (reqStartRegex.test(tLine)) {
      const match = tLine.match(reqStartRegex)!
      currentBlock = 'req'
      currentObj = {
        type: match[1],
        name: match[2].trim(),
        id: '', text: '', risk: 'medium', verifyMethod: 'test'
      }
    } else if (elemStartRegex.test(tLine)) {
      const match = tLine.match(elemStartRegex)!
      currentBlock = 'elem'
      currentObj = {
        name: match[1].trim(),
        type: 'component',
        docRef: ''
      }
    } else if (relationRegex.test(tLine)) {
      const match = tLine.match(relationRegex)!
      newRels.push({
        source: match[1].trim(),
        type: match[2].trim(),
        target: match[3].trim()
      })
    }
  }

  if (newReqs.length > 0) requirements.value = newReqs
  if (newElems.length > 0) elements.value = newElems
  if (newRels.length > 0) relations.value = newRels
}

// Watchers
watch(() => props.open, (newVal) => {
  if (newVal) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        editableCode.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        syncToVisual();
      }, 300);
      return;
    }
  }

  if (newVal && !editableCode.value) {
    generateMermaid()
  }
}, { immediate: true })

watch([requirements, elements, relations], () => {
  generateMermaid()
}, { deep: true })

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(editableCode.value)
    copied.value = true
    setTimeout(() => copied.value = false, 2000)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}

const saveAndClose = () => {
  emit('save', editableCode.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseVisualEditor, {
    open: __props.open,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:open', $event))),
    title: "Diagrama de Requisitos",
    description: "Diseña la trazabilidad entre requisitos del sistema y elementos que los satisfacen (Estilo SysML).",
    showCode: showCode.value,
    "onUpdate:showCode": _cache[2] || (_cache[2] = ($event: any) => (showCode.value = $event)),
    copied: copied.value,
    onCopy: copyToClipboard,
    onSave: saveAndClose
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(ClipboardList), { class: "w-5 h-5 text-primary" })
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "sm",
        variant: "default",
        onClick: addRequirement
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FileCheck2), { class: "w-4 h-4 mr-2" }),
          _cache[3] || (_cache[3] = _createTextVNode(" Añadir Requisito", -1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        size: "sm",
        variant: "secondary",
        onClick: addElement
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Box), { class: "w-4 h-4 mr-2" }),
          _cache[4] || (_cache[4] = _createTextVNode(" Añadir Elemento", -1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        size: "sm",
        variant: "outline",
        onClick: addRelation
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Link2), { class: "w-4 h-4 mr-2" }),
          _cache[5] || (_cache[5] = _createTextVNode(" Vincular (Relación)", -1))
        ]),
        _: 1
      })
    ]),
    canvas: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createVNode(_unref(FileCheck2), { class: "w-5 h-5" }),
            _cache[6] || (_cache[6] = _createTextVNode(" Requisitos", -1))
          ]),
          (requirements.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Sin requisitos definidos. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requirements.value, (req, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'req'+idx,
                class: "flex flex-col gap-2 bg-muted/40 border p-3 rounded-md relative"
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeRequirement(idx)),
                  class: "absolute right-2 top-2 text-muted-foreground hover:text-destructive transition-colors bg-background p-1 rounded-md"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Nombre (Alias)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((req.name) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none",
                      placeholder: "Nombre"
                    }, null, 8, _hoisted_9), [
                      [_vModelText, req.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Tipo de Requisito", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((req.type) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reqTypes, (t) => {
                        return _createElementVNode("option", {
                          key: t,
                          value: t
                        }, _toDisplayString(t), 9, _hoisted_12)
                      }), 64))
                    ], 8, _hoisted_11), [
                      [_vModelSelect, req.type]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "ID Ref", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((req.id) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none",
                      placeholder: "REQ-01"
                    }, null, 8, _hoisted_15), [
                      [_vModelText, req.id]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Riesgo", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((req.risk) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(riskTypes, (r) => {
                        return _createElementVNode("option", {
                          key: r,
                          value: r
                        }, _toDisplayString(r), 9, _hoisted_18)
                      }), 64))
                    ], 8, _hoisted_17), [
                      [_vModelSelect, req.risk]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Verificación", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((req.verifyMethod) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(verifyTypes, (v) => {
                        return _createElementVNode("option", {
                          key: v,
                          value: v
                        }, _toDisplayString(v), 9, _hoisted_21)
                      }), 64))
                    ], 8, _hoisted_20), [
                      [_vModelSelect, req.verifyMethod]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Texto (Descripción)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => ((req.text) = $event),
                    class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none h-16 resize-none",
                    placeholder: "Describe el requerimiento..."
                  }, null, 8, _hoisted_23), [
                    [_vModelText, req.text]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h3", _hoisted_25, [
            _createVNode(_unref(Box), { class: "w-5 h-5" }),
            _cache[13] || (_cache[13] = _createTextVNode(" Elementos del Sistema", -1))
          ]),
          (elements.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Sin elementos definidos. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elements.value, (el, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'el'+idx,
                class: "flex flex-col gap-2 bg-muted/40 border p-3 rounded-md relative"
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeElement(idx)),
                  class: "absolute right-2 top-2 text-muted-foreground hover:text-destructive transition-colors bg-background p-1 rounded-md"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_28),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Nombre (Alias)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((el.name) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none",
                      placeholder: "Nombre"
                    }, null, 8, _hoisted_31), [
                      [_vModelText, el.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Tipo Técnico", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((el.type) = $event),
                      class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none",
                      placeholder: "Ej. software_component"
                    }, null, 8, _hoisted_33), [
                      [_vModelText, el.type]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-[10px] font-bold uppercase text-muted-foreground ml-1" }, "Ref Documento (Opcional)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((el.docRef) = $event),
                    class: "bg-background border rounded px-2 py-1 text-sm focus:ring-1 focus:outline-none",
                    placeholder: "Ej. doc_arq_12"
                  }, null, 8, _hoisted_35), [
                    [_vModelText, el.docRef]
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h3", _hoisted_37, [
            _createVNode(_unref(Link2), { class: "w-5 h-5" }),
            _cache[17] || (_cache[17] = _createTextVNode(" Trazabilidad (Relaciones)", -1))
          ]),
          (relations.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Sin relaciones de trazabilidad. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relations.value, (rel, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'rel'+idx,
                class: "flex flex-wrap items-center gap-2 bg-background border p-2 rounded-md shadow-sm"
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((rel.source) = $event),
                  class: "bg-muted border rounded px-2 py-1 text-sm focus:outline-none flex-1 min-w-[120px]"
                }, [
                  _createElementVNode("optgroup", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elements.value, (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'src_e_'+e.name,
                        value: e.name
                      }, _toDisplayString(e.name), 9, _hoisted_42))
                    }), 128))
                  ]),
                  _createElementVNode("optgroup", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requirements.value, (r) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'src_r_'+r.name,
                        value: r.name
                      }, _toDisplayString(r.name), 9, _hoisted_44))
                    }), 128))
                  ])
                ], 8, _hoisted_40), [
                  [_vModelSelect, rel.source]
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((rel.type) = $event),
                  class: "bg-primary/10 border-primary/20 text-primary border rounded px-2 py-1 text-sm focus:outline-none font-semibold"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(relationTypes, (t) => {
                    return _createElementVNode("option", {
                      key: t,
                      value: t
                    }, "- " + _toDisplayString(t) + " ->", 9, _hoisted_46)
                  }), 64))
                ], 8, _hoisted_45), [
                  [_vModelSelect, rel.type]
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((rel.target) = $event),
                  class: "bg-muted border rounded px-2 py-1 text-sm focus:outline-none flex-1 min-w-[120px]"
                }, [
                  _createElementVNode("optgroup", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requirements.value, (r) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'tgt_r_'+r.name,
                        value: r.name
                      }, _toDisplayString(r.name), 9, _hoisted_49))
                    }), 128))
                  ]),
                  _createElementVNode("optgroup", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elements.value, (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'tgt_e_'+e.name,
                        value: e.name
                      }, _toDisplayString(e.name), 9, _hoisted_51))
                    }), 128))
                  ])
                ], 8, _hoisted_47), [
                  [_vModelSelect, rel.target]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeRelation(idx)),
                  class: "text-muted-foreground hover:bg-destructive hover:text-white p-2 rounded-full transition-colors ml-2 shrink-0"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_52)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    "code-panel": _withCtx(() => [
      _createElementVNode("div", _hoisted_53, [
        _cache[19] || (_cache[19] = _createTextVNode(" Mermaid (Sincronizado) ", -1)),
        _createVNode(_unref(Button), {
          size: "sm",
          variant: "default",
          class: "h-7 text-xs",
          onClick: syncToVisual
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshCw), { class: "w-3 h-3 mr-2" }),
            _cache[18] || (_cache[18] = _createTextVNode(" Sincronizar a Visual ", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(MermaidCodeEditor, {
        modelValue: editableCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableCode).value = $event)),
        class: "flex-1 min-h-0"
      }, null, 8, ["modelValue"])
    ]),
    "live-preview": _withCtx(() => [
      _createVNode(MermaidLivePreview, { code: editableCode.value }, null, 8, ["code"])
    ]),
    _: 1
  }, 8, ["open", "showCode", "copied"]))
}
}

})